require('../../modules/es6.array.find');
module.exports = require('../../modules/_core').Array.find;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/fn/array/find.js
// module id = 229
// module chunks = 168707334958949